export default __webpack_public_path__ + "static/occhio-logo-2848139627f4f635b9eadeb9db1327f6.png";